export default "__VITE_ASSET__Dxdiy9NN__"